import { useState } from "react"
import InputItem from "../../components/InputItem"
import Loading from "../../components/Loading"
import CStack from "../../components/CStack"
import SwitchControl from "../../components/SwitchControl"
import { Stack, Button, Spinner } from "react-bootstrap"
import BaseControl from "../../components/BaseControl"
import { useSupportStore } from "../../api/personalization/support/store"

const Support = () => {
    const { retrieveData, data, loading, updateData } = useSupportStore(state => state)
    const [edit, setEdit] = useState(false)
    const [dirty, setDirty] = useState(false)
    const [editedData, setEditedData] = useState(data)
    const [applying, setApplying] = useState(false)
    
    if (!loading && data === null) retrieveData()
    if (data !== null && editedData === null) setEditedData(data)

    const onChangedValue = (key: string, val: any) => {
        const newData = {
            ...editedData,
            [key]: val
        }
        setEditedData(newData)
        setDirty(true)
    }

    const onToggleEdit = (checked: boolean) => {
        if (!checked) {
            setDirty(false)
            setEditedData(data)
        }
        setEdit(checked)
    }

    const onApplyEdit = async () => {
        setApplying(true)
        await updateData(editedData)
        setDirty(false)
        setEdit(false)
        setApplying(false)
    }

    return <>
        {loading && <Loading expandHeight />}
        {data !== null && editedData !== null && <>
            <SwitchControl text="Edit Mode" value={edit} onChanged={onToggleEdit} />

            <CStack header="Contact Information">
                <InputItem
                    edit={edit}
                    text="Contact Number 1"
                    value={editedData.supportContactNumber1}
                    id="supportContactNumber1"
                    onChanged={(id, val) => onChangedValue(id, val)}
                />
                <InputItem
                    edit={edit}
                    text="Contact Number 2"
                    value={editedData.supportContactNumber2}
                    id="supportContactNumber2"
                    onChanged={(id, val) => onChangedValue(id, val)}
                />
                <InputItem
                    edit={edit}
                    text="Email Address"
                    value={editedData.supportEmailAddress}
                    id="supportEmailAddress"
                    onChanged={(id, val) => onChangedValue(id, val)}
                />
            </CStack>

            <CStack header="Links">
                <InputItem
                    edit={edit}
                    text="FAQ"
                    value={editedData.faqsLink}
                    id="faqsLink"
                    onChanged={(id, val) => onChangedValue(id, val)}
                />
                <InputItem
                    edit={edit}
                    text="Security Tips"
                    value={editedData.securityTipsLink}
                    id="securityTipsLink"
                    onChanged={(id, val) => onChangedValue(id, val)}
                />
                <InputItem
                    edit={edit}
                    text="Privacy Policy"
                    value={editedData.privacyPolicyLink}
                    id="privacyPolicyLink"
                    onChanged={(id, val) => onChangedValue(id, val)}
                />
                <InputItem
                    edit={edit}
                    text="Terms and Conditions"
                    value={editedData.termConditionLink}
                    id="termConditionLink"
                    onChanged={(id, val) => onChangedValue(id, val)}
                />
            </CStack>

            {edit && <BaseControl text="Apply changes?">
                <Stack direction="horizontal" gap={2}>
                    <Button size="sm" onClick={() => onToggleEdit(false)} variant="outline-secondary">Cancel</Button>
                    <Button size="sm" disabled={!dirty || applying} onClick={onApplyEdit} variant="primary">
                        {!applying ? "Apply" :
                            <Stack direction="horizontal" gap={1}>
                                <Spinner size="sm" />Applying
                            </Stack>}
                    </Button>
                </Stack>
            </BaseControl>}
        </>}
    </>
}

export default Support
